<header class="header">
  <div class="logo">
    <img
      ngSrc="assets/img/logo.png"
      priority="high"
      alt="logo"
      width="130"
      height="30"
    />
  </div>
  @let environment = translate.instant("environmentLabel");
  @let title = translate.instant("appName");
  @if (environment && title) {
    <div class="name">
      {{ title }}
      <span class="environment-indication">
        <span class="material-symbols-outlined"> app_badging </span>
        {{ environment }}
      </span>
    </div>
  }
  <div class="profile" [matMenuTriggerFor]="logoutMenu">
    <span class="username"
      >{{ userProfile?.name }}
      @if (activeUserRoles()) {
        <span class="user-role"
          >({{ activeUserRoles().replaceAll(",", ", ") || "" }})</span
        >
      }
    </span>
    <span class="material-symbols-outlined">account_circle</span>
    <mat-menu #logoutMenu="matMenu" xPosition="before" yPosition="below">
      <button mat-menu-item (click)="logoutUser()">
        <div class="flex">
          <span class="material-symbols-outlined">logout</span>
          <span>{{ "logOut" | translate }}</span>
        </div>
      </button>
    </mat-menu>
  </div>
</header>
